/** Final Documents List renumbering (Phase 103) — display only. The
 * document types created for the Final Documentation Checklist keep their
 * stored names, which carry the form's old numbers (it jumped from 4 to 6);
 * these are the names they are shown with. Mirrors RENUMBERED_TYPE_NAMES in
 * backend/src/modules/students/finalDocumentChecklist.ts. A type renamed in
 * Master Data is shown as renamed. */
const RENUMBERED_TYPE_NAMES: Record<string, string> = {
  'Final 6 — Medical report (Park Hospital receipt)': 'Final 5 — Medical report (Park Hospital receipt)',
  'Final 7 — Lawyer letter with Supreme Court attestation': 'Final 6 — Lawyer letter with Supreme Court attestation',
  'Final 8a — 20 passport-size photographs': 'Final 7a — 20 passport-size photographs',
  'Final 8b — High-resolution digital photo': 'Final 7b — High-resolution digital photo',
  'Final 9 — Affidavit (name differences)': 'Final 8 — Affidavit (name differences)',
  'Final 10 — Consent letter (under 18)': 'Final 9 — Consent letter (under 18)',
};

/** How a document is named on screen: an Other document by the name the
 * student gave it, anything else by its (renumbered) type name. */
export const documentDisplayName = (documentTypeName: string, customName?: string | null) =>
  customName ? `Other document — ${customName}` : (RENUMBERED_TYPE_NAMES[documentTypeName] ?? documentTypeName);

/** The files the server accepts for a student document (upload.ts's
 * documentFileFilter and MAX_UPLOAD_MB). Checked here first so a student
 * hears about it before waiting for an upload; the server still decides. */
export const DOCUMENT_ACCEPT = '.pdf,.jpg,.jpeg,.png,.doc,.docx';
export const MAX_DOCUMENT_MB = 25;

export const documentFileProblem = (file: File): string | null => {
  const ext = file.name.includes('.') ? file.name.slice(file.name.lastIndexOf('.')).toLowerCase() : '';
  if (!DOCUMENT_ACCEPT.split(',').includes(ext)) {
    return `${file.name}: unsupported file type. Use PDF, JPG, PNG, DOC or DOCX.`;
  }
  if (file.size > MAX_DOCUMENT_MB * 1024 * 1024) {
    return `${file.name} is larger than ${MAX_DOCUMENT_MB} MB.`;
  }
  if (file.size === 0) return `${file.name} is empty.`;
  return null;
};

export const CUSTOM_NAME_MAX = 150;
